var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "inline-select-operator",
      class: { open: _vm.dropdownVisible, placeholder: !_vm.selectedLabel },
    },
    [
      _c(
        "a-dropdown",
        {
          attrs: { trigger: ["click"] },
          model: {
            value: _vm.dropdownVisible,
            callback: function ($$v) {
              _vm.dropdownVisible = $$v
            },
            expression: "dropdownVisible",
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "select-trigger",
              on: {
                click: function ($event) {
                  _vm.dropdownVisible = !_vm.dropdownVisible
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.selectedLabel || _vm.placeholder) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-menu",
            {
              staticClass: "inline-select-operator-menu",
              attrs: { slot: "overlay" },
              slot: "overlay",
            },
            _vm._l(_vm.options, function (option) {
              return _c(
                "a-menu-item",
                {
                  key: option.value,
                  on: {
                    click: function ($event) {
                      return _vm.selectOption(option)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(option.label) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }